export default __webpack_public_path__ + "static/media/back_arrow.4b2a0aa6.svg";